const packageJson = require("../package.json");

module.exports = {
  title: packageJson.title,
  publicPath: "/",
  version: require("../package.json").version,
  api: {
    fullPath: process.env.VUE_APP_API_URL
  },

  // default
  defaultConfigs: {
    gtm: process.env.VUE_GTM,
    efunAPIUrl: process.env.VUE_EFUN_API_URL,
    efunWebUrl: process.env.VUE_EFUN_WEB_URL,
    locale: "tw",
    dense: true,
    footer: false,
    drawer: {
      show: false,
      dense: false
      // logo: require('@/assets/image/logo.png')
    },
    fullscreen: {
      show: false,
      btn: true
    },
    settingsPanel: {
      show: false,
      btn: true
    },
    theme: {
      index: 0,
      dark: false
    },
    overlayLoading: false
  }
};
